export const setTabUnreadCount = (() => {
  const originalTitle = document.title;
  let lastCount = null;
  return count => {
    if (count === lastCount) return;
    lastCount = count;
    if (count) document.title = `(${count}) ${originalTitle}`;else document.title = originalTitle;
  };
})();